<h1 style="font-weight: bold;
    font-size: x-large;
    text-align: center;">Terminated/Amended Plan</h1>

<p-table
  [value]="listOfEntries"
  [first]="first"
  [lazy]="true"
  [totalRecords]="paginator.totalCount"
  [rows]="paginator.pageSize"
  [showCurrentPageReport]="true"
  [tableStyle]="{ 'min-width': '50rem' }"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  (onPage)="pageChange($event)"
  dataKey="entryId"
  [rowsPerPageOptions]="[10, 25, 50]"
>
  <ng-template #header>
    <tr>
      <th >Trading Plan Id</th>
       <th >Issuer Name</th>
        <th >Insider Name</th>
         <th >Reference Date</th>
      <th >Plan Action</th>
      <th style="width: 15%">URL</th>
    </tr>
  </ng-template>
  <ng-template #body let-share>
    <tr
      [pSelectableRow]="share"
      [ngClass]="{
        'row-duplicate': share.status === 'DUPLICATE',
        'row-excluded': share.status === 'EXCLUDED'
      }"
    >
      <td>{{ share.tradingPlanId || "N/A" }}</td>
      <td>{{ share.issuerName || "N/A" }}</td>
      <td>{{ share.insiderName || "N/A" }}</td>
      <td>{{ share.referenceDate || "N/A" }}</td>
      <td>{{ (share.planAction | titlecase) || "N/A" }}</td>
      <td>
        <a href="{{ share.thisUrl }}" *ngIf="share.thisUrl" target="_blank"
        >Link</a
        >

        <span *ngIf="!share.thisUrl">-</span>
      </td>
      <!--      <td>{{ share.planAction || "N/A" }}</td>-->
    </tr>
  </ng-template>
</p-table>

<br>
<br>

<h1 style="font-weight: bold;
    font-size: x-large;
    text-align: center;">Adoption Plans</h1>
<p-table
  [value]="listOfEntries"
  [first]="first"
  [lazy]="true"
  [totalRecords]="paginator.totalCount"
  [rows]="paginator.pageSize"
  [showCurrentPageReport]="true"
  [tableStyle]="{ 'min-width': '50rem' }"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  (onPage)="pageChange($event)"
  dataKey="entryId"
  [rowsPerPageOptions]="[10, 25, 50]"
>
  <ng-template #header>
    <tr>
      <th style="width: 25%">Trading Plan Id</th>
      <th style="width: 25%">Plan Action</th>
      <th style="width: 15%">URL</th>
      <th style="width: 25%">Action</th>
    </tr>
  </ng-template>
  <ng-template #body let-share>
    <tr
      [pSelectableRow]="share"
      [ngClass]="{
        'row-duplicate': share.status === 'DUPLICATE',
        'row-excluded': share.status === 'EXCLUDED'
      }"
    >
      <td>{{ share.adoptionTradingPlanId || "N/A" }}</td>
      <td>{{ share.adoptionTradingPlanId ? "Adoption" : "N/A" }}</td>
      <td>
        <a href="{{ share.adoptionUrl }}" *ngIf="share.adoptionUrl" target="_blank"
        >Link</a
        >

        <span *ngIf="!share.adoptionUrl">-</span>
      </td>
      <!--      <td>{{ share.planAction || "N/A" }}</td>-->

      <td class="flex space-x-2">

        <button
          class="bg-white hover:bg-[#2a3450] text-#2a3450 cursor-pointer hover:text-white py-1 px-3 border border-gray-400 rounded mr-2"
          (click)="onExcludeClick(share, 'MODIFY')">
          Modify
        </button>

        <button
          class="bg-white hover:bg-[#2a3450] text-#2a3450 cursor-pointer hover:text-white py-1 px-3 border border-gray-400 rounded mr-2"
          (click)="onExcludeClick(share, 'EXCLUDED')">
          Exclude
        </button>
        <button
          class="bg-white hover:bg-[#2a3450] text-#2a3450 cursor-pointer hover:text-white py-1 px-3 border border-gray-400 rounded mr-2"
          (click)="onExcludeClick(share, 'CONNECT')">
          Connect
        </button>
      </td>

    </tr>
  </ng-template>
</p-table>

<p-toast>

</p-toast>
